import { PluginEnv } from '@atlassian/post-office-frontend';

import { getEnv } from '../config';

export function getPostOfficeEnv(): PluginEnv {
  const env = getEnv();

  switch (env) {
    case 'local':
      return 'local';
    case 'test':
      return 'test';
    case 'ddev':
      return 'dev';
    case 'stg-east':
    case 'stg-apse':
    case 'stg-fedm-east':
      return 'staging';
    case 'prod-east':
    case 'prod-fedm-east':
      return 'production';
    default:
      return 'staging';
  }
}
